module.exports = __webpack_public_path__ + "img/8.e0d143b3.png";